import NavigationBar from "../components/navBar";
import Footer from "../components/footer";
import './policy.css'
import { useEffect } from "react";
import HeroSection from "../components/HeroSection";
import { useLocation } from "react-router-dom";

export default function Policy() {
    const location = useLocation();

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "instant" });
        const el = document.querySelector(".page-transition");
        if (el) {
            el.classList.add("show");
        }
    }, []);

    return (
        <div className="page-transition">
            <NavigationBar />
            <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.0/css/all.min.css"></link>

            {/* Hero Section */}
            <HeroSection title="Privacy & Policy" theme="aboutus" previousPath={location.state?.from} />

            <div className="policy-container">
                <div className="policy-page">
                    <p className="policy-effective-date">Effective Date: January 1, 2025</p>
                    <p className="policy-intro">At Google Developers Group on Campus (GDG on Campus), we value your privacy and are committed to protecting your personal information. This Privacy Policy explains how we collect, use, and safeguard information when you interact with our community, website, or events.</p>

                    <h2 className="policy-info">1. Information We Collect</h2>
                    <p>We collect different types of information to improve your experience and deliver meaningful programs:</p>
                    <h3>a. Personal Information</h3>
                    <ul>
                        <li>Name, student ID (if required), and university/college details</li>
                        <li>Email address, phone number, or other contact details you provide</li>
                        <li>Professional or academic background when registering for events, workshops, or conferences</li>
                    </ul>

                    <h3>b. Technical and Usage Information</h3>
                    <ul>
                        <li>IP address, device type, operating system, and browser details</li>
                        <li>Pages you visit on our website or online platforms</li>
                        <li>Cookies and similar technologies that help us understand how our site is used</li>
                    </ul>
                    <h3>c. Event and Community Participation</h3>
                    <ul>
                        <li>Registration details for workshops, hackathons, and conferences</li>
                        <li>Feedback and surveys submitted by participants</li>
                        <li>Photographs, audio, or video recordings from GDG events (with prior notice and consent)</li>
                    </ul>
                    <h3>d. Voluntary Information</h3>
                    <p>Any additional details you choose to share with us, such as suggestions, project contributions, or submissions to our community initiatives.</p>

                    <h2>2. How We Use Your Information</h2>
                    <p>We use the information we collect for purposes such as:</p>
                    <ul>
                        <li>Managing event registrations and providing necessary updates</li>
                        <li>Communicating important announcements, reminders, and follow-ups</li>
                        <li>Sharing learning resources, technical content, and collaboration opportunities</li>
                        <li>Recognizing participation and contributions in community activities</li>
                        <li>Analyzing community engagement and improving our programs</li>
                        <li>Ensuring compliance with university guidelines and Google Developers policies</li>
                    </ul>

                    <h2>3. Information Sharing and Disclosure</h2>
                    <p>We respect your privacy and do not sell your information. However, we may share your information in the following cases:</p>
                    <ul>
                        <li><b>Event Partners and Sponsors:</b> When events are co-organized with partner organizations, sponsors, or mentors, limited information (like name and email) may be shared for event management purposes.</li>
                        <li><b>Google Developers & Affiliates:</b> To align local campus events with global GDG programs, initiatives, and opportunities.</li>
                        <li><b>Legal Compliance:</b> If required by applicable law, university regulations, or to protect the safety and rights of community members.</li>
                        <li><b>Consent-Based Sharing:</b> When you explicitly agree for your information to be shared for networking, certificates, or showcasing achievements.</li>
                    </ul>

                    <h2>4. Data Retention</h2>
                    <p>We retain your personal data only as long as it is necessary for the purposes stated in this Privacy Policy, unless a longer retention period is required by law. Information related to event participation may be stored for future references, certificates, or alumni tracking.</p>

                    <h2>5. Cookies and Tracking Technologies</h2>
                    <p>Our website and digital platforms may use cookies and similar technologies to:</p>
                    <ul>
                        <li>Track website traffic and analyze user behavior</li>
                        <li>Improve site functionality and user experience</li>
                        <li>Remember your preferences for future visits</li>
                    </ul>
                    <p>You can choose to disable cookies in your browser settings, but this may affect certain features of our platforms.</p>

                    <h2>6. Data Security</h2>
                    <p>We take appropriate technical and organizational measures to protect your data against unauthorized access, alteration, disclosure, or loss. However, no method of transmission over the Internet or method of electronic storage is 100% secure.</p>

                    <h2>7. Your Rights</h2>
                    <p>As a member of the GDG on Campus community, you have the right to:</p>
                    <ul>
                        <li>Access the personal information we hold about you</li>
                        <li>Request corrections to inaccurate or outdated information</li>
                        <li>Withdraw consent and request deletion of your personal data</li>
                        <li>Opt out of promotional emails and community updates</li>
                    </ul>
                    <p>To exercise these rights, please contact us at [Insert Contact Email].</p>

                    <h2>8. Children’s Privacy</h2>
                    <p>Our community is primarily designed for university and college students. We do not knowingly collect personal data from individuals under 16 years of age. If you believe we have inadvertently collected such information, please contact us to request deletion.</p>

                    <h2>9. Social Media and Third-Party Links</h2>
                    <p>GDG on Campus may maintain official social media pages (e.g., Facebook, Twitter/X, LinkedIn, Discord, Slack). Please note:</p>
                    <ul>
                        <li>Any information shared on these platforms is subject to the privacy policies of the respective service.</li>
                        <li>Our website or communications may contain links to third-party websites, which have their own privacy practices.</li>
                    </ul>
                    <p>We encourage you to review the policies of these external sites before interacting with them.</p>

                    <h2>10. International Considerations</h2>
                    <p>As part of the global GDG network, your information may be shared with affiliates or systems located outside your country. We take steps to ensure that your data is protected in accordance with this Privacy Policy.</p>

                    <h2>11. Changes to This Privacy Policy</h2>
                    <p>We may update this Privacy Policy from time to time to reflect changes in practices, regulations, or community needs. The updated version will always be available on our website with a new “Effective Date.”</p>

                    <h2>12. Contact Us</h2>
                    <p>If you have any questions, concerns, or requests regarding this Privacy Policy, please contact us at:</p>
                    <p>Email us at: 📧<a href="https://mail.google.com/mail/u/0/#inbox/FMfcgzQcpnNNpJdSwmcmWjmkSSDCpvKj?compose=DmwnWslzDPBzQPcjwtQQTBMpLvkRGFRcgLGPtpwfxSCTxhDLpNJmNPKFTJNnCxxmrkzFQFmHmlglQFmHmlgl">gdsc@ustp.edu.ph</a></p>
                    <p>Message us at: <a href="https://www.facebook.com/dscustp" target="_blank" rel="noopener noreferrer">
                        <i className="fab fa-facebook"></i> Facebook
                    </a></p>
                    <p>You may also visit us at our office located in <b>Building 5, Near Alumni Federation Office, USTP CDO</b></p>

                </div>
            </div>
            <Footer />
        </div>

    );
}